import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, SearchX, ShieldAlert, Laptop } from 'lucide-react';
export const Problem = () => {
  const problems = [{
    icon: <Clock className="w-6 h-6 text-red-400" data-id="element-220" data-mp="2bfzk82mkcvxa" />,
    title: 'Perdés horas buscando información.',
    desc: 'Cada nuevo caso implica investigar desde cero, buscar jurisprudencia, adaptar modelos y organizar documentación.'
  }, {
    icon: <SearchX className="w-6 h-6 text-red-400" data-id="element-221" data-mp="21od3jqrgi4n5" />,
    title: 'Trabajás con material disperso.',
    desc: 'Tus modelos están en carpetas distintas, los fallos en otro lado y las estrategias dependen de lo que recuerdes.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-red-400" data-id="element-222" data-mp="1wqjxqyu2fcne" />,
    title: 'Inseguridad al actuar.',
    desc: 'La duda sobre si estás utilizando el mejor argumento, la mejor estrategia o la jurisprudencia más adecuada.'
  }, {
    icon: <Laptop className="w-6 h-6 text-red-400" data-id="element-223" data-mp="1np3mkovff6i4" />,
    title: 'Te cuesta incorporar nuevas herramientas.',
    desc: 'IA jurídica, prueba digital, protección de datos, litigación oral y marketing jurídico ya forman parte de la profesión moderna.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-red-400" data-id="element-224" data-mp="12ad7ylhuvpac" />,
    title: 'Improvisación constante.',
    desc: 'Cada consulta parece empezar desde cero cuando deberías contar con un sistema profesional organizado.'
  }];
  return <section className="py-12 bg-legal-900" data-id="element-225" data-mp="9mr1n5h8u6js">
      <div className="container mx-auto px-4" data-id="element-226" data-mp="9jlg207tpmst">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-227" data-mp="5ldyj35jchgk">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-228" data-mp="jbhc75qcn2ue">
            Ejercer sin un sistema profesional completo te hace perder{' '}
            <span className="text-red-400" data-id="element-229" data-mp="ejpw5p4tkfii">
              tiempo, dinero y oportunidades.
            </span>
          </h2>
          <p className="text-lg text-slate-400" data-id="element-230" data-mp="3myhr35kidm3l">
            El derecho está cambiando más rápido que nunca. Hoy no alcanza con
            conocer la ley. Los abogados necesitan herramientas, tecnología,
            estrategias y sistemas de trabajo que les permitan resolver más
            casos en menos tiempo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-231" data-mp="1vph70aaktfv6">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`bg-legal-800/50 border border-red-900/30 p-6 rounded-xl flex gap-4 ${idx === 4 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-232" data-mp="20m7nuzu7gfhn" data-mpi={idx}>
              <div className="shrink-0 mt-1" data-id="element-233" data-mp="2sdninh5x18iy">{prob.icon}</div>
              <div data-id="element-234" data-mp="gr3h5jva4y44">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-235" data-mp="grl944awsq68">
                  {prob.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-236" data-mp="cr1eb7dt5yn9">
                  {prob.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};